import React from 'react'
import {LandingPageNavbar, Footer} from "../component"


type ContactProps = {}

const Contact = (props: ContactProps) => {
  return (
    <div>
        <LandingPageNavbar />
        Contact
        <Footer />
    </div>
  )
}

export default Contact